module.exports = __webpack_public_path__ + "static/media/kcc.7f405ef0.png";